'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import FormattedMessage from 'I18n/components/FormattedMessage';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { LORAX } from 'HubStyleTokens/colors';
import UISelectableButton from 'UIComponents/button/UISelectableBox';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import Branding from 'MeetingsBase/models/Branding';
import { getColorStyleWithOpacity } from 'MeetingsLib/utils/color';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import SafeStorage from 'SafeStorage';
import StyledSprocketIcon from 'MeetingsLib/components/freemium/StyledSprocketIcon';
import { getEnvPostfix } from 'MeetingsBase/utils/utils';
export default createReactClass({
  displayName: "FreemiumUpgradeButton",
  propTypes: {
    handleButtonClick: PropTypes.func.isRequired,
    branding: PropTypes.instanceOf(Branding).isRequired
  },
  getInitialState: function getInitialState() {
    return {
      variation: 'control',
      treatmentFetched: false,
      experimentEnabled: false
    };
  },
  componentDidMount: function componentDidMount() {
    track('meetingsViralityPageView', {
      action: 'virality-thank-you-page-view'
    });
    var experimentIdentifier = this.generateRandomIdentifier('meetings-virality-experiment');
    this.setupExperiment(experimentIdentifier);
  },
  generateRandomIdentifier: function generateRandomIdentifier(param) {
    var storedExperimentIdentifier = param + "-exp-id";
    var random = SafeStorage.getItem(storedExperimentIdentifier);

    if (!random) {
      random = Math.random();
      SafeStorage.setItem(storedExperimentIdentifier, random);
    }

    return random;
  },
  setupExperiment: function setupExperiment(experimentIdentifier) {
    var _this = this;

    var experimentTimeout = setTimeout(this.handleTimeout, 1000); // 1 second to get the treatment, else we render the default.

    var postfix = getEnvPostfix();
    noAuthApiClient.get("https://api.hubspot" + postfix + ".com/treatments/v1/get/acquisition-039/" + experimentIdentifier).then(function (treatment) {
      return _this.handleTreatmentFetched(treatment, experimentTimeout);
    }).catch(function () {
      _this.handleError();
    });
  },
  handleTreatmentFetched: function handleTreatmentFetched(treatment, experimentTimeout) {
    clearTimeout(experimentTimeout);

    if (treatment && treatment.parameters && treatment.parameters.length !== undefined) {
      var parameter = treatment.parameters[0]; // if the button has already rendered, don't change it

      if (!this.state.treatmentFetched) {
        this.setState({
          variation: parameter.value,
          treatmentFetched: true,
          experimentEnabled: parameter.isAssigned
        });
      }

      if (parameter.isAssigned) {
        track('meetingsLibViralityExperiment', {
          action: 'view',
          variation: this.state.variation
        });
      }
    } else {
      this.handleError();
    }
  },
  handleTimeout: function handleTimeout() {
    var treatmentFetched = this.state.treatmentFetched;

    if (!treatmentFetched) {
      this.setState({
        treatmentFetched: true
      });
      track('meetingsLibViralityExperiment', {
        action: 'error',
        variation: 'timeout'
      });
    }
  },
  handleError: function handleError() {
    track('meetingsLibViralityExperiment', {
      action: 'error',
      variation: 'error'
    });
    this.setState({
      treatmentFetched: true
    });
  },
  handleViralButtonClick: function handleViralButtonClick() {
    if (this.state.experimentEnabled) {
      track('meetingsLibViralityExperiment', {
        action: 'click',
        variation: this.state.variation
      });
    }

    this.props.handleButtonClick();
  },
  getBrandingActiveStyle: function getBrandingActiveStyle() {
    var primaryColor = this.props.branding.primaryColor;

    if (!primaryColor) {
      return null;
    }

    return {
      width: 'auto',
      borderColor: primaryColor,
      backgroundColor: getColorStyleWithOpacity(primaryColor)
    };
  },
  getBrandingTextStyle: function getBrandingTextStyle() {
    var primaryColor = this.props.branding.primaryColor;

    if (!primaryColor) {
      return null;
    }

    return {
      color: primaryColor
    };
  },
  render: function render() {
    var handleButtonClick = this.props.handleButtonClick;
    var _this$state = this.state,
        variation = _this$state.variation,
        experimentEnabled = _this$state.experimentEnabled,
        treatmentFetched = _this$state.treatmentFetched;
    var isVariant = variation === 'variant' && experimentEnabled;
    return treatmentFetched ? isVariant ? /*#__PURE__*/_jsxs(UIButton, {
      className: "m-top-8",
      use: "primary",
      onClick: this.handleViralButtonClick,
      children: [/*#__PURE__*/_jsx(StyledSprocketIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.meetingsAdvert.freemium"
      })]
    }) : /*#__PURE__*/_jsxs(UISelectableButton, {
      padded: false,
      selected: false,
      className: "freemium-advert-button",
      style: this.getBrandingActiveStyle(),
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onClick: handleButtonClick,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "sprocket",
        color: LORAX,
        className: "m-right-1"
      }), /*#__PURE__*/_jsx("span", {
        style: this.getBrandingTextStyle(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.meetingsAdvert.freemium"
        })
      })]
    }) : null;
  }
});